<template>
  <tbody>
    <tr v-for="(lot, i) in getRows()" :key="i">
      <td class="text-center white-space-nowrap">
        {{ lot.name }}
      </td>
      <template v-for="ribbonData in lot.columns">
        <template v-for="ribbon in ribbonData">
          <td v-if="option === 'balanceVariablesByRibbon'" class="text-center">
            {{ ribbon.pocket }}
          </td>
          <td v-if="option === 'balanceVariablesByRibbon'" class="text-center">
            {{ ribbon.cutting }}
          </td>
          <td v-if="option === 'balanceVariablesByRibbon'" class="text-center">
            {{ ribbon.ringing }}
          </td>
          <td class="text-center">
            {{ ribbon.balance }}
          </td>
          <percent-cell-balance
            :value="ribbon.balance"
            :percent="ribbon.percent"
          />
        </template>
      </template>
    </tr>
  </tbody>
</template>
<script>
import { getSumOfValorFromArray } from 'src/util/Util.js';
import Formatter from 'src/class/Formatter';
import MixinMasters from 'src/util/mixinMasters';
import PercentCellBalance from './PercentCellBalance.vue';

export default {
  name: 'tbody-ribbons-balances',
  components: {
    [PercentCellBalance.name]: PercentCellBalance,
  },
  props: {
    rows: {
      type: Array | Object,
      default: [],
    },
    columns: {
      type: Array | Object,
      default: [],
    },
    totalColumns: {
      type: Array | Object,
      default: [],
    },
    data: {
      type: Array | Object,
      default: () => {
        return [];
      },
    },
    option: {
      type: String,
      default: 'ribbonsBalances',
    },
  },
  mixins: [MixinMasters],
  methods: {
    getRows() {
      return this.rows.map((row) => {
        const respColumns = Object.keys(this.columns).map((week) => {
          const respRibbons = this.columns[week].map((ribbon) => {
            const values = this.getNumberClusters(
              week,
              row.numberLot,
              ribbon.color_name
            );
            return {
              ...ribbon,
              balance: values[0],
              percent: values[1],
              pocket: values[2],
              cutting: values[3],
              ringing: values[4],
            };
          });

          return respRibbons;
        });

        return { ...row, columns: respColumns };
      });
    },

    getNumberClusters(week, lot, ribbon) {
      const array = [];
      try {
        array.push(
          this.data['cutting'][week][lot].filter(
            (obj) => obj.color_name === ribbon
          )
        );
      } catch (error) {
        array.push([0]);
      }

      try {
        array.push(
          this.data['pocket'][week][lot].filter(
            (obj) => obj.color_name === ribbon
          )
        );
      } catch (error) {
        array.push([0]);
      }

      try {
        array.push(
          this.data['ringing'][week][lot].filter(
            (obj) => obj.color_name === ribbon
          )
        );
      } catch (error) {
        array.push([0]);
      }

      const cutting = getSumOfValorFromArray(
        array[0].map((data) => data.number_clusters)
      );
      const pocket = getSumOfValorFromArray(
        array[1].map((data) => data.number_clusters)
      );
      const ringing = getSumOfValorFromArray(
        array[2].map((data) => data.number_clusters)
      );

      const totalCluster = pocket - cutting - ringing;
      const totalPocket = this.getTotalPocket(week, ribbon);
      const totalReponse = 1 - totalCluster / totalPocket;
      let percent = '';

      if (Number(totalCluster) === 0) percent = '100%';
      else if (Number(totalPocket) === 0) percent = '0%';
      else
        percent =
          totalReponse == 0
            ? '0%'
            : `${Formatter.formatNumber((totalReponse * 100).toFixed(2))}%`;

      return [
        Formatter.formatNumber(totalCluster),
        percent,
        Formatter.formatNumber(pocket),
        Formatter.formatNumber(cutting),
        Formatter.formatNumber(ringing),
      ];
    },

    getTotalPocket(week, ribbon) {
      let totalPocket = 0;
      try {
        const filtered = this.totalColumns['pocket'][week][ribbon];
        totalPocket = Array.isArray(filtered)
          ? getSumOfValorFromArray(filtered)
          : getSumOfValorFromArray(Object.values(filtered));
      } catch (error) {
        totalPocket = 0;
      }

      return totalPocket;
    },
  },
};
</script>
